/**
 * Admin / Superuser access helpers for the admin app.
 *
 * In Boomtown, Admin usertype is `users.role === 1` (`usertype_admin`).
 * In this app Admin and Superuser are treated as the same access level.
 */

/** Boomtown `users::usertype_admin` */
export const ADMIN_USER_ROLE = 1 as const;

export const ADMIN_ACCESS_DENIED_MESSAGE =
  'Only Admin users can access this application.';

export class AdminAccessDeniedError extends Error {
  constructor(message: string = ADMIN_ACCESS_DENIED_MESSAGE) {
    super(message);
    this.name = 'AdminAccessDeniedError';
  }
}

export interface IAdminAccessUser {
  role?: number;
  id?: string;
  email?: string;
  _perms?: number[] | null;
}

/**
 * Returns true when the user is an Admin (role === 1).
 * Fail closed when role is missing.
 */
export function isAdminSuperuser(user: IAdminAccessUser | null | undefined): boolean {
  if (!user) {
    return false;
  }
  return user.role === ADMIN_USER_ROLE;
}
